import { AAGUID, CountryCode } from '@interticket/core';
import { LanguageCode } from '@interticket/core';
import { IAddress } from '@core/interfaces/address/address.interface';

export class Address implements IAddress {

  readonly addressGuid?: AAGUID;
  readonly type?: number;
  readonly state?: string;
  readonly country: CountryCode;
  readonly county?: string;
  readonly zipCode: string;
  readonly postalCode?: string;
  readonly city: string;
  readonly district?: string;
  readonly street: string;
  readonly houseNumber: string;
  readonly building?: string;
  readonly stairway?: string;
  readonly floor: string;
  readonly door: string;
  readonly comment?: string;
  readonly longitude?: number;
  readonly latitude?: number;
  readonly timezone?: number;

  constructor(iAddress: IAddress) {
    this.addressGuid = iAddress.addressGuid;
    this.type = iAddress.type;
    this.state = iAddress.state;
    this.country = iAddress.country;
    this.county = iAddress.county;
    this.zipCode = iAddress.zipCode;
    this.postalCode = iAddress.postalCode;
    this.city = iAddress.city;
    this.district = iAddress.district;
    this.street = iAddress.street;
    this.houseNumber = iAddress.houseNumber;
    this.building = iAddress.building;
    this.stairway = iAddress.stairway;
    this.floor = iAddress.floor;
    this.door = iAddress.door;
    this.comment = iAddress.comment;
    this.longitude = iAddress.longitude;
    this.latitude = iAddress.latitude;
    this.timezone = iAddress.timezone;
  }

  private boundHU(floorStr: string): string {
    let address = `${this.zipCode} ${this.city}, ${this.street} ${this.houseNumber}`;
    if (this.floor) {
      address += ` ${this.floor}. ${floorStr}`;
    }
    if (this.door) {
      address += ` ${this.door}`;
    }
    return address;
  }

  private boundEN(floorStr: string): string {
    let address = '';
    if (this.door) {
      address += `${this.door} `;
    }
    if (this.floor) {
      address += `${this.floor}. ${floorStr} `;
    }
    address += `${this.houseNumber} ${this.street}, ${this.city} ${this.zipCode}`;
    return address;
  }

  private boundDK(floorStr: string): string {
    return `${this.street} ${this.houseNumber}, ${this.zipCode} ${this.city}`;
  }

  /**
   * Bound the address informations in the specified language format
   */
  bound(lang: string, floorStr = 'emelet'): string {
    switch (lang) {
      case LanguageCode.HU: return this.boundHU(floorStr);
      case LanguageCode.EN: return this.boundEN(floorStr);
      case LanguageCode.DA: return this.boundDK(floorStr);
      default: return this.boundDK(floorStr);
    }
  }

  /**
   * Bound the address data to display on Google Maps according to geocoder query format
   * {@link}: https://developers.google.com/maps/faq#geocoder_queryformat
   */
  boundForMap(): string {
    let address = `${this.houseNumber}, ${this.street}, ${this.city}, ${this.zipCode}`;
    if (this.state) {
      address += `, ${this.state}`;
    }
    if (this.country) {
      address += `, ${this.country}`;
    }
    return address;
  }

}
